import React from "react";
import { LabelDate, LabelDollarFormatted, LabelPercentFormatted, LabelString } from "@loanbossinc/component-library";

export const assetDataTableSoldDealColumns = [
  {
    id: "name",
    label: "Deal",
    path: "name",
    Cell: value => <LabelString value={value} />
  },
  {
    id: "paidOffDate",
    label: "Paid Off Date",
    path: "loans[0].paidOffDate",
    Cell: value => <LabelDate value={value} />
  },
  {
    id: "exitCap",
    label: "Exit Cap",
    path: "filteredDealMetric.exitCap",
    Cell: value => (
      <LabelPercentFormatted value={value} decimals={2} />
    )
  },
  {
    id: "salesPrice",
    label: "Sales Price",
    path: "filteredDealMetric.salesPrice",
    sortAsNumber: true,
    Cell: value => <LabelDollarFormatted value={value} decimals={2} />
  }
];
